import { Box, Typography } from '@mui/material'
import ScrollDownIndicator from '../common/ScrollDownIndicator'
import PrimaryButton from '../common/PrimaryButton'
import { plcHero } from '../../data/plcContent'
import {
  MOBILE_MQ,
  mobileBodyTextSx,
  mobilePaddingX,
  mobileSectionPy,
  mobileSectionTitleSx,
} from '../../theme/mobileLayout'

export default function PlcHeroSection() {
  return (
    <Box
      component="section"
      sx={{
        width: '100%',
        maxWidth: 1920,
        mx: 'auto',
        minHeight: { xs: 560, md: 800, lg: 1080 },
        px: mobilePaddingX,
        pt: { ...mobileSectionPy, md: '120px', lg: '260px' },
        pb: { xs: 6, md: 8 },
        [MOBILE_MQ]: { minHeight: 560 },
        boxSizing: 'border-box',
        bgcolor: '#fffefa',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          maxWidth: 1000,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { xs: 3, lg: '42px' },
          textAlign: 'center',
          flex: 1,
          justifyContent: 'center',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 2, lg: '20px' }, width: '100%' }}>
          <Typography
            component="h1"
            sx={{
              ...mobileSectionTitleSx,
              fontSize: { ...mobileSectionTitleSx.fontSize, xs: 22, lg: 80 },
            }}
          >
            {plcHero.title}
          </Typography>
          <Typography
            sx={{
              ...mobileBodyTextSx,
              fontSize: { ...mobileBodyTextSx.fontSize, md: 26, lg: 26 },
            }}
          >
            {plcHero.subtitle}
          </Typography>
        </Box>

        <PrimaryButton to="/contact">
          Register Now
        </PrimaryButton>
      </Box>

      <ScrollDownIndicator
        sx={{
          mt: { xs: 6, md: 8, lg: 'auto' },
          pb: { lg: '80px' },
        }}
        textSx={{ fontSize: { xs: 16, md: 22 } }}
      />
    </Box>
  )
}
